import { graphql } from "./generated/index.js"

// Insert many attachments in one mutation (the reference write path's batched add).
//
// Same conflict shape as taggings: UNIQUE (record_id, asset_id) with no
// schema_key. An unqualified (aggregate) row is ADOPTED into the field being
// written; a row another field already stamped is NOT updated (the `where`
// excludes it), drops out of `returning`, and the count check raises instead
// of silently stealing it. `asset_type` is NOT NULL with no default —
// buildObjects derives it from the asset's mime_type.
export const insertManyRecordAttachments = graphql(`
  mutation insertManyRecordAttachments($objects: [record_attachments_insert_input!]!) {
    insert_record_attachments(
      objects: $objects
      on_conflict: {
        constraint: record_attachments_record_id_asset_id_unique
        update_columns: [schema_key, schema_id, asset_type]
        where: { schema_key: { _is_null: true } }
      }
    ) {
      returning {
        ...RecordAttachmentFields
      }
    }
  }
`)

export const deleteAttachmentsByIds = graphql(`
  mutation deleteAttachmentsByIds($ids: [Int!]!) {
    delete_record_attachments(where: { id: { _in: $ids } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`)


export const updateRecordAttachment = graphql(`
  mutation updateRecordAttachment($id: Int!, $_set: record_attachments_set_input!) {
    update_record_attachments_by_pk(pk_columns: { id: $id }, _set: $_set) {
      ...RecordAttachmentFields
    }
  }
`)

export const updateManyRecordAttachments = graphql(`
  mutation updateManyRecordAttachments($updates: [record_attachments_updates!]!) {
    update_record_attachments_many(updates: $updates) {
      affected_rows
      returning {
        ...RecordAttachmentFields
      }
    }
  }
`)

export const unsetOtherPrimaryAttachments = graphql(`
  mutation unsetOtherPrimaryAttachments($recordId: Int!, $excludeId: Int!) {
    update_record_attachments(
      where: { record_id: { _eq: $recordId }, id: { _neq: $excludeId } }
      _set: { is_primary: false }
    ) {
      affected_rows
    }
  }
`)
